import { Route, Routes } from 'react-router-dom';
import { UsersPage } from './UsersPage';
import { UpdateUserPage } from './UpdateUserPage';
import { CreateUserPage } from './CreateUserPage';

export const UserPageRoot = () => (
  <Routes>
    <Route path='/new' element={<CreateUserPage />} />
    <Route path='/:userID' element={<UpdateUserPage />} />
    <Route path='*' element={<UsersPage />} />
  </Routes>
);
